import * as React from 'react';
export var DataTableContext = React.createContext({
  selectedRowIds: [],
  unselectRows: function unselectRows() {},
  data: []
});